// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApplicationTab {
  background-color: #F4F4F4 !important;
  height: auto;
}
.ApplicationTab .tab-container {
  position: relative;
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: center;
  height: 100%;
}
.ApplicationTab .tab-container .tab {
  position: relative;
  z-index: 0;
  cursor: pointer;
  transition: all 0.2s ease-in;
  color: #694779;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  flex: 1 1;
  justify-content: center;
  font-size: 18px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  width: 400px;
  font-size: 18px;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
  padding: 29px 0px;
}
.ApplicationTab .tab-container div:before,
.ApplicationTab .tab-container div:after {
  position: absolute;
  bottom: -1px;
  width: 20px;
  height: 20px;
  content: " ";
}
.ApplicationTab .tab-container div:before {
  left: -20px;
  border-bottom-right-radius: 20px;
  border-width: 0 1px 1px 0;
}
.ApplicationTab .tab-container div:after {
  right: -20px;
  border-bottom-left-radius: 20px;
  border-width: 0 0 1px 1px;
}
.ApplicationTab .tab-container .selected-tab:before {
  transition: 0.2s ease-in;
  box-shadow: 7px 3.5px 0 #fff;
}
.ApplicationTab .tab-container .selected-tab:after {
  transition: 0.2s ease-in;
  box-shadow: -7px 3.5px 0 #fff;
}
.ApplicationTab .tab-container .selected-tab {
  background-color: white;
  color: black;
}
.ApplicationTab .tab-container .tab-content {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 451px) {
  .ApplicationTab .tab-container {
    width: 100%;
  }
  .ApplicationTab .tab-container .tab {
    font-size: 15px;
    padding: 5px;
  }
}
@media screen and (max-width: 554px) {
  .ApplicationTab {
    height: 70px;
    margin-top: 165px;
  }
}
@media screen and (max-width: 768px) {
  .ApplicationTab .tab-container {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-snap-type: x mandatory;
    scroll-margin-left: 20px;
    scroll-behavior: smooth;
    touch-action: pan-x;
    overflow-y: hidden;
    -webkit-touch-callout: none;
    -webkit-user-drag: none;
  }
  .ApplicationTab .tab-container::-webkit-scrollbar {
    display: none;
  }
  .ApplicationTab .tab-container .tab {
    min-width: 33.3333333333%;
    flex: 1 1;
    text-align: center;
    cursor: pointer;
  }
  .ApplicationTab .tab {
    padding: 10px 20px;
    transition: background-color 0.3s ease;
  }
  .ApplicationTab .selected-tab {
    background-color: #ccc;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/ApplicationTab/ApplicationTab.scss","webpack://./src/containers/ChooseAFlight/themevariable.scss"],"names":[],"mappings":"AAGA;EACE,oCAAA;EAEA,YAAA;AAHF;AAKE;EACE,kBAAA;EAGA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AALJ;AAOI;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,4BAAA;EACA,cCrBgB;EDsBhB,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,6BAAA;EAEA,YAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAPN;AAUI;;EAEE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AARN;AAWI;EACE,WAAA;EACA,gCAAA;EACA,yBAAA;AATN;AAWI;EACE,YAAA;EACA,+BAAA;EACA,yBAAA;AATN;AAYI;EACE,wBAAA;EACA,4BAAA;AAVN;AAYI;EACE,wBAAA;EACA,6BAAA;AAVN;AAaI;EAEE,uBAAA;EACA,YAAA;AAZN;AAeI;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbN;;AAkBA;EAEI;IACE,WAAA;EAhBJ;EAkBI;IACE,eAAA;IACA,YAAA;EAhBN;AACF;AAqBA;EACE;IACE,YAAA;IACA,iBAAA;EAnBF;AACF;AAsBA;EAEI;IACE,aAAA;IACA,gBAAA;IACA,mBAAA;IACA,qBAAA;IACA,wBAAA;IACA,6BAAA;IACA,wBAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;IACA,2BAAA;IACA,uBAAA;EArBJ;EAsBI;IACE,aAAA;EApBN;EAuBI;IACE,yBAAA;IACA,SAAA;IACA,kBAAA;IACA,eAAA;EArBN;EAyBE;IACE,kBAAA;IACA,sCAAA;EAvBJ;EA0BE;IACE,sBAAA;EAxBJ;AACF","sourcesContent":["@use \"src/styles/variables\" as var;\n@use \"src/containers/ChooseAFlight/themevariable\" as theme;\n\n.ApplicationTab {\n  background-color: theme.$searchPanelBackgroundColor !important;\n  // height: 70px;\n  height: auto;\n\n  .tab-container {\n    position: relative;\n    // max-width: $page-width;\n    // max-width:1050px;\n    width: 90%;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n\n    .tab {\n      position: relative;\n      z-index: 0;\n      cursor: pointer;\n      transition: all 0.2s ease-in;\n      color: theme.$customPrimaryColor;\n      user-select: none;\n      display: flex;\n      align-items: center;\n      flex: 1 1 0;\n      justify-content: center;\n      font-size: 18px;\n      border-top-left-radius: 25px;\n      border-top-right-radius: 25px;\n      // max-width: 300px;\n      width: 400px;\n      //font-family: \"FKGroteskNeue-Regular\", serif;\n      font-size: 18px;\n      font-weight: 400;\n      line-height: 23px;\n      letter-spacing: 0em;\n      text-align: center;\n      padding: 29px 0px;\n    }\n\n    div:before,\n    div:after {\n      position: absolute;\n      bottom: -1px;\n      width: 20px;\n      height: 20px;\n      content: \" \";\n    }\n\n    div:before {\n      left: -20px;\n      border-bottom-right-radius: 20px;\n      border-width: 0 1px 1px 0;\n    }\n    div:after {\n      right: -20px;\n      border-bottom-left-radius: 20px;\n      border-width: 0 0 1px 1px;\n    }\n\n    .selected-tab:before {\n      transition: 0.2s ease-in;\n      box-shadow: 7px 3.5px 0 #fff;\n    }\n    .selected-tab:after {\n      transition: 0.2s ease-in;\n      box-shadow: -7px 3.5px 0 #fff;\n    }\n\n    .selected-tab {\n      // z-index: 3;\n      background-color: white;\n      color: black;\n    }\n\n    .tab-content {\n      height: 400px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n@media screen and (var.$mobile-media) {\n  .ApplicationTab {\n    .tab-container {\n      width: 100%;\n\n      .tab {\n        font-size: 15px;\n        padding: 5px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 554px) {\n  .ApplicationTab {\n    height: 70px;\n    margin-top: 165px;\n  }\n}\n//tab\n@media screen and (max-width: 768px) {\n  .ApplicationTab {\n    .tab-container {\n      display: flex;\n      overflow-x: auto;\n      white-space: nowrap;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n      scroll-snap-type: x mandatory;\n      scroll-margin-left: 20px;\n      scroll-behavior: smooth;\n      touch-action: pan-x;\n      overflow-y: hidden;\n      -webkit-touch-callout: none;\n      -webkit-user-drag: none;\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .tab {\n        min-width: calc(100% / 3);\n        flex: 1;\n        text-align: center;\n        cursor: pointer;\n      }\n    }\n\n    .tab {\n      padding: 10px 20px;\n      transition: background-color 0.3s ease;\n    }\n\n    .selected-tab {\n      background-color: #ccc;\n    }\n  }\n}\n","$defaultBackgroundColor : #FFFFFF;\n$defaultFontColor : #000000;\n$customPrimaryColor : #694779;\n$customFontColor : #FFFFFF;\n$searchPanelBackgroundColor : #F4F4F4;\n$descriptionFontColor : #2C3034;\n$customSecondaryColor : #F1F4F9;\n$listItemFeatureFontColor : #535A61;\n$conciergeButtonBackgroundColor : #B9A691;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
